function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 28,
  height: 28,
  rx: 14,
  fill: "#C5D1C0"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.276 16.593l6.761-6.761-.942-.943-6.762 6.761v.943h.943zm.553 1.334H8v-2.83l7.623-7.623a.667.667 0 01.943 0l1.886 1.886a.667.667 0 010 .943l-7.623 7.623zM8 19.26h12v1.333H8V19.26z",
  fill: "#36443A"
});

function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjI4IiBoZWlnaHQ9IjI4IiByeD0iMTQiIGZpbGw9IiNDNUQxQzAiLz4KPHBhdGggZD0iTTEwLjI3NiAxNi41OTMyTDE3LjAzNzMgOS44MzE4MkwxNi4wOTQ3IDguODg5MTVMOS4zMzMzMyAxNS42NTA1VjE2LjU5MzJIMTAuMjc2Wk0xMC44Mjg3IDE3LjkyNjVIOFYxNS4wOTc4TDE1LjYyMzMgNy40NzQ0OUMxNS43NDg0IDcuMzQ5NTEgMTUuOTE3OSA3LjI3OTMgMTYuMDk0NyA3LjI3OTNDMTYuMjcxNCA3LjI3OTMgMTYuNDQxIDcuMzQ5NTEgMTYuNTY2IDcuNDc0NDlMMTguNDUyIDkuMzYwNDlDMTguNTc3IDkuNDg1NTEgMTguNjQ3MiA5LjY1NTA1IDE4LjY0NzIgOS44MzE4MkMxOC42NDcyIDEwLjAwODYgMTguNTc3IDEwLjE3ODEgMTguNDUyIDEwLjMwMzJMMTAuODI4NyAxNy45MjY1Wk04IDE5LjI1OThIMjBWMjAuNTkzMkg4VjE5LjI1OThaIiBmaWxsPSIjMzY0NDNBIi8+Cjwvc3ZnPgo=";
export { SvgEdit as ReactComponent };